import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = {
  class: "bg-ob-deep-900 flex justify-center"
};
const _hoisted_2 = {
  class: "bg-ob-deep-900 rounded-lg max-w-10/12 lg:max-w-screen-2xl text-sm text-ob-normal w-full py-6 px-6 grid grid-rows-1 lg:grid-rows-none lg:grid-cols-4 justify-center items-center gap-8"
};
const _hoisted_3 = {
  class: "flex flex-col lg:flex-row gap-6 lg:gap-12 row-span-1 lg:col-span-3 text-center lg:text-left"
};
const _hoisted_4 = {
  class: "flex flex-col gap-1.5"
};
const _hoisted_5 = {
  class: "font-extrabold"
};
const _hoisted_6 = {
  href: "https://github.com/adminy/aurora"
};
const _hoisted_7 = {
  class: "font-extrabold border-b-2 border-ob hover:text-ob"
};
const _hoisted_8 = {
  key: 0,
  class: "flex flex-row gap-3"
};
const _hoisted_9 = {
  key: 0
};
const _hoisted_10 = ["src"];
const _hoisted_11 = ["href"];
const _hoisted_12 = {
  class: "font-extrabold border-b-2 border-ob hover:text-ob"
};
const _hoisted_13 = {
  key: 1
};
const _hoisted_14 = ["href"];
const _hoisted_15 = {
  class: "font-extrabold border-b-2 border-ob hover:text-ob"
};
const _hoisted_16 = {
  key: 0
};
const _hoisted_17 = {
  id: "busuanzi_container_site_pv"
};
const _hoisted_18 = {
  id: "busuanzi_container_site_uv"
};
const _hoisted_19 = {
  class: "hidden lg:flex lg:col-span-1 justify-center lg:justify-end row-span-1 relative"
};
const _hoisted_20 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_svg_icon = _resolveComponent("svg-icon");
  return _openBlock(), _createElementBlock("div", {
    id: "footer",
    class: "relative w-full pt-1",
    style: _normalizeStyle(_ctx.gradientBackground)
  }, [_createElementVNode("span", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("ul", _hoisted_4, [_createElementVNode("li", null, [_createTextVNode(" Copyright © 2019 - " + _toDisplayString(_ctx.currentYear) + " ", 1 /* TEXT */), _createElementVNode("b", _hoisted_5, _toDisplayString(_ctx.themeConfig.site.author), 1 /* TEXT */), _cache[0] || (_cache[0] = _createTextVNode(" . All Rights Reserved. "))]), _createElementVNode("li", null, [_cache[1] || (_cache[1] = _createTextVNode(" Powered by ")), _cache[2] || (_cache[2] = _createElementVNode("a", {
    href: "https://hexo.io/"
  }, [_createElementVNode("b", {
    class: "font-extrabold border-b-2 border-ob hover:text-ob"
  }, " Hexo ")], -1 /* HOISTED */)), _cache[3] || (_cache[3] = _createTextVNode(" & Themed by ")), _createElementVNode("a", _hoisted_6, [_createElementVNode("b", _hoisted_7, " Aurora v" + _toDisplayString(_ctx.themeConfig.version), 1 /* TEXT */)]), _cache[4] || (_cache[4] = _createTextVNode(" . "))]), _ctx.themeConfig.site.beian.number !== '' || _ctx.themeConfig.site.police_beian.number !== '' ? (_openBlock(), _createElementBlock("li", _hoisted_8, [_ctx.themeConfig.site.police_beian.number !== '' ? (_openBlock(), _createElementBlock("span", _hoisted_9, [_createElementVNode("img", {
    class: "inline-block",
    src: require('@/assets/gongan-beian-40-40.png'),
    alt: "",
    width: "15"
  }, null, 8 /* PROPS */, _hoisted_10), _createElementVNode("b", null, [_cache[5] || (_cache[5] = _createTextVNode(" 公安备案信息： ")), _createElementVNode("a", {
    href: _ctx.themeConfig.site.police_beian.link
  }, [_createElementVNode("b", _hoisted_12, _toDisplayString(_ctx.themeConfig.site.police_beian.number), 1 /* TEXT */)], 8 /* PROPS */, _hoisted_11)])])) : _createCommentVNode("v-if", true), _ctx.themeConfig.site.beian.number !== '' ? (_openBlock(), _createElementBlock("span", _hoisted_13, [_cache[6] || (_cache[6] = _createTextVNode(" 备案信息： ")), _createElementVNode("a", {
    href: _ctx.themeConfig.site.beian.link
  }, [_createElementVNode("b", _hoisted_15, _toDisplayString(_ctx.themeConfig.site.beian.number), 1 /* TEXT */)], 8 /* PROPS */, _hoisted_14)])) : _createCommentVNode("v-if", true)])) : _createCommentVNode("v-if", true)]), _ctx.themeConfig.plugins.busuanzi.enable ? (_openBlock(), _createElementBlock("ul", _hoisted_16, [_createElementVNode("li", null, [_createElementVNode("span", _hoisted_17, [_createVNode(_component_svg_icon, {
    "icon-class": "eye",
    class: "mr-1 text-lg inline-block"
  }), _cache[7] || (_cache[7] = _createElementVNode("span", {
    id: "busuanzi_value_site_pv"
  }, null, -1 /* HOISTED */))])]), _createElementVNode("li", null, [_createElementVNode("span", _hoisted_18, [_createVNode(_component_svg_icon, {
    "icon-class": "people",
    class: "mr-1 text-lg inline-block"
  }), _cache[8] || (_cache[8] = _createElementVNode("span", {
    id: "busuanzi_value_site_uv"
  }, null, -1 /* HOISTED */))])])])) : _createCommentVNode("v-if", true)]), _createElementVNode("div", _hoisted_19, [_withDirectives(_createElementVNode("img", {
    class: _normalizeClass(_ctx.avatarClass),
    src: _ctx.themeConfig.site.avatar,
    alt: "avatar"
  }, null, 10 /* CLASS, PROPS */, _hoisted_20), [[_vShow, _ctx.themeConfig.site.avatar]])])])])], 4 /* STYLE */);
}